import React from "react"
import ReactPlayer from "react-player"

import PlaylistForm from "../playlist-404"
import { playlists } from "../country-playlist"

import "./_playlist.scss"

const Playlist = ({ country, isMenuOpen }) => {
  return (
    <div className={`playlist ${isMenuOpen && "playlist--open"}`}>
      <div className="playlist__player">
        {(playlists as any)[country][1] == "" ? (
          <PlaylistForm country={(playlists as any)[country][0]} />
        ) : (
          <div className="playlist__player-wrapper">
            <ReactPlayer
              className="playlist__react-player"
              height="86.5vh"
              width="100%"
              playing={true}
              url={`https://soundcloud.com/user-360563285/sets/${
                (playlists as any)[country][1]
              }`}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default Playlist
